import { format, parseISO } from 'date-fns';

/**
 * Безопасно парсит строку YYYY-MM-DD в локальный Date
 * Предотвращает сдвиг на 1 день в часовых поясах UTC+
 * 
 * Проблема: new Date("2026-07-01") парсит как UTC 00:00
 * В Москве (UTC+3) это становится 30 июня 21:00
 * 
 * Решение: parseISO из date-fns корректно обрабатывает локальный TZ
 */
export function parseLocalDate(dateString: string): Date {
  if (!dateString) throw new Error('dateString is required');
  return parseISO(dateString);
}

/**
 * Форматирует Date в строку YYYY-MM-DD в локальном TZ
 * Замена для date.toISOString().split('T')[0]
 * 
 * Проблема: toISOString() конвертирует в UTC, сдвигая дату назад
 * Решение: format() сохраняет локальную дату
 */
export function formatLocalDate(date: Date): string {
  return format(date, 'yyyy-MM-dd');
}
